import React, {useEffect, useRef} from 'react';
import styled from 'styled-components';
import {
  ExpressCheckoutUserData,
  PayPalStyleOptions,
  SDKInstance,
} from './ExpressCheckout/types';

interface Props {
  data: ExpressCheckoutUserData;
  source: string;
  sdk: SDKInstance;
  onButtonMount: () => void;
}

const paypalBtnStyleOption: PayPalStyleOptions = {
  layout: 'horizontal',
  color: 'blue',
  tagline: false,
  shape: 'rect',
  label: 'buynow',
  branding: true,
};

export const PayPalCheckoutButton: React.FC<Props> = ({
  data,
  sdk,
  onButtonMount,
  source,
}) => {
  const paypalButtonRef = useRef<HTMLDivElement>(null);

  useEffect(
    () => {
      if (data) {
        onButtonMount();
        sdk.loadPayment({
          htmlContainer: paypalButtonRef.current,
          configuration: data.payment.configuration,
          paymentKey: data.payment.key,
          styleOptions: paypalBtnStyleOption,
          source,
        });
      }
    },
    data ? [data.payment.configuration, data.payment.key] : [null, null],
  );

  return (
    <PaypalButtonContainer
      data-testid="expressCheckoutPayPalButton"
      ref={paypalButtonRef}
    />
  );
};

const PaypalButtonContainer = styled.div`
  // impacting mobile version
  // script loaded button(iframe element) will have z-index of 100 which is more then off-canvas
  position: relative;
  z-index: 0;
`;
